import { computed, MaybeRefOrGetter, toValue } from 'vue';
import { getProductBySku } from '@/features/Product/composables/productLookupHelper';
import { BundleItem, ProductComplete, ValuePrice } from '@/features/Product/types/models';

export const getChoiceGroupFillCount = (item: BundleItem) =>
  item.minSelection ?? item.quantity ?? 1;

const choiceGroupTotal = (item: BundleItem) => {
  const prices = (item.processedProducts ?? [])
    .map((product) => product.attributes?.price ?? 0)
    .filter((price) => price > 0);
  if (!prices.length) return 0;
  return Math.min(...prices) * getChoiceGroupFillCount(item);
};

const valuePriceTotal = (valuePrice: ValuePrice) =>
  valuePrice.reduce((total, { sku, quantity }) => {
    const price = getProductBySku(sku)?.attributes?.price ?? 0;
    return total + price * quantity;
  }, 0);

export const useBundleItemTotal = (
  product: MaybeRefOrGetter<ProductComplete | null | undefined>,
) => {
  const individualItemsTotal = computed(() => {
    const activeProduct = toValue(product);

    const valuePrice = activeProduct?.content?.valuePrice;
    if (valuePrice) return valuePriceTotal(valuePrice);

    const items = activeProduct?.bundleDefinition?.bundleItems;
    if (!items) return 0;
    return items.reduce((total, item) => {
      if (item.itemType === 'choice_group') {
        return total + choiceGroupTotal(item);
      }
      const itemTotal = (item.processedProducts ?? []).reduce(
        (sum, p) => sum + (p.attributes?.price ?? 0),
        0,
      );
      return total + itemTotal * (item.quantity || 1);
    }, 0);
  });

  return { individualItemsTotal };
};
